import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { triggerExpandReviewEvent } from '../utilities/analytics';
import Truncate from './Truncate';

import '../global-sass/main.scss';

class ReadMore extends Component {
	constructor(...args) {
		super(...args);

		this.state = {
			expanded: false,
			truncated: false
		};

		this.handleTruncate = this.handleTruncate.bind(this);
		this.toggleLines = this.toggleLines.bind(this);
	}

	handleTruncate(truncated) {
		if (this.state.truncated !== truncated) {
			this.setState({
				truncated
			});
		}
	}

	toggleLines(event, element, elementCTA, result, windowId, widgetName) {
		event.preventDefault();
		triggerExpandReviewEvent(
			element,
			elementCTA,
			result,
			windowId,
			widgetName
		);
		this.setState({
			expanded: !this.state.expanded
		});
	}

	render() {
		const {
			children,
			more,
			less,
			lines,
			windowId,
			widgetName,
			labels
		} = this.props;

		const { expanded, truncated } = this.state;

		const readMoreLinkClasses = ['read-more-link', 'text-link', 'd-block'];
		return (
			<div className="review-body">
				<Truncate
					lines={!expanded && lines}
					ellipsis={
						<span>
							&hellip;{' '}
							<button
								className={readMoreLinkClasses.join(' ')}
								onClick={event => {
									this.toggleLines(
										event,
										'Read more link',
										more,
										'Review expanded',
										windowId,
										widgetName
									);
								}}
							>
								{labels.get(more)}
							</button>
						</span>
					}
					onTruncate={this.handleTruncate}
				>
					{children}
				</Truncate>
				{!truncated && expanded && (
					<span>
						{' '}
						<button
							className={readMoreLinkClasses.join(' ')}
							onClick={event => {
								this.toggleLines(
									event,
									'Read less link',
									less,
									'Review collapsed',
									windowId,
									widgetName
								);
							}}
						>
							{labels.get(less)}
						</button>
					</span>
				)}
			</div>
		);
	}
}

ReadMore.defaultProps = {
	lines: 2,
	more: 'READ_MORE',
	less: 'SHOW_LESS'
};

ReadMore.propTypes = {
	children: PropTypes.node.isRequired,
	more: PropTypes.string,
	less: PropTypes.string,
	lines: PropTypes.number,
	windowId: PropTypes.string.isRequired,
	widgetName: PropTypes.string.isRequired,
	labels: PropTypes.shape({}).isRequired
};

export default ReadMore;



// WEBPACK FOOTER //
// ./src/components/ReadMore.jsx